module.exports = __webpack_public_path__ + "img/douyin.a3e6527d.png";